import { createReducer } from '../../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import BaseUrlConfig from '../../../../net/BaseUrlConfig';
import UrlConfig from '../../../../net/UrlConfig';
import {
    START_QUERY_GROUP_COMPANY_REGISTER,
    QUERY_GROUP_COMPANY_REGISTER_SUCCESS,
    QUERY_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_QUERY_GROUP_COMPANY_REGISTER_ACTION_STATUS,
    GROUP_COMPANY_REGISTER_QUERY_CHANGE_INPUT,
    SELECT_GROUP_COMPANY_REGISTER,
    OPEN_GROUP_COMPANY_REGISTER_DETAIL_DIALOG,
    RESET_GROUP_COMPANY_REGISTER_DETAIL_DIALOG,
    OPEN_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL,
    RESET_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL,
    ADD_OR_EDIT_GROUP_COMPANY_REGISTER_CHANGE_INPUT,
    START_SUBMIT_ADD_GROUP_COMPANY_REGISTER,
    SUBMIT_ADD_GROUP_COMPANY_REGISTER_SUCCESS,
    SUBMIT_ADD_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_SUBMIT_ADD_GROUP_COMPANY_REGISTER_ACTION_STATUS,
    START_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER,
    SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_SUCCESS,
    SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_ACTION_STATUS,
    OPEN_DEL_GROUP_COMPANY_REGISTER_MODAL,
    RESET_DEL_GROUP_COMPANY_REGISTER_MODAL,
    START_SUBMIT_DEL_GROUP_COMPANY_REGISTER,
    SUBMIT_DEL_GROUP_COMPANY_REGISTER_SUCCESS,
    SUBMIT_DEL_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_SUBMIT_DEL_GROUP_COMPANY_REGISTER_ACTION_STATUS,
} from './GroupCompanyRegisterConstants';

const CURRENT_END_DATE = '9999-12-31';

const initialModalFields = {
    id: undefined,
    companyCode: undefined,
    information: undefined,
    details: undefined,
    effectiveDate: undefined,
    endDate: undefined,
    attachment: undefined,
    attachmentOriginName: undefined,
    attachmentFileList: [],
    lastUpdatedBy: undefined,
    lastUpdateTime: undefined,
};

const initialState = {
    queryFields: {
        companyCode: undefined,
        information: 'ALL',
        currentStatus: 'Current',
    },
    selectedGroupCompanyRegisterArray: [],
    groupCompanyRegisterUploadUrl: BaseUrlConfig.api.REST_URL + BaseUrlConfig.api.API_VERSION + UrlConfig.GROUP_COMPANY_REGISTER_UPLOAD_URL,
    groupCompanyRegisterDownloadUrl: BaseUrlConfig.api.REST_URL + BaseUrlConfig.api.API_VERSION + UrlConfig.GROUP_COMPANY_REGISTER_DOWNLOAD_URL,
    groupCompanyRegisterDetailDialog: {
        isOpened: false,
        fields: initialModalFields,
    },
    groupCompanyRegisterModal: {
        isOpened: false,
        mode: 'ADD',
        respErrMsg: '',
        fields: initialModalFields,
    },
    delGroupCompanyRegisterModal: {
        isOpened: false,
        respErrMsg: '',
        fields: {
            id: undefined,
        },
    },
};

function startQueryGroupCompanyRegister(state) {
    return {
        ...state,
        queryGroupCompanyRegisterStatus: ACTION_STATUS.LOGINING,
    };
}

function queryGroupCompanyRegisterSuccess(state, resp) {
    return {
        ...state,
        queryGroupCompanyRegisterStatus: ACTION_STATUS.SUCCESS,
        queryGroupCompanyRegisterResp: resp,
    };
}

function queryGroupCompanyRegisterFailure(state, err) {
    return {
        ...state,
        queryGroupCompanyRegisterStatus: ACTION_STATUS.ERROR,
        queryGroupCompanyRegisterResp: err,
    };
}

function initQueryGroupCompanyRegisterActionStatus(state) {
    return {
        ...state,
        queryGroupCompanyRegisterStatus: ACTION_STATUS.READY,
        selectedGroupCompanyRegisterArray: [],
    };
}

function groupCompanyRegisterQueryChangeInput(state, { name, value }) {
    return {
        ...state,
        queryFields: {
            ...state.queryFields,
            [name]: value,
        },
    };
}

function selectGroupCompanyRegister(state, array) {
    return {
        ...state,
        selectedGroupCompanyRegisterArray: array,
    };
}

function openGroupCompanyRegisterDetailDialog(state, data) {
    return {
        ...state,
        groupCompanyRegisterDetailDialog: {
            isOpened: true,
            fields: {
                ...initialModalFields,
                ...data,
            },
        },
    };
}

function resetGroupCompanyRegisterDetailDialog(state) {
    return {
        ...state,
        groupCompanyRegisterDetailDialog: initialState.groupCompanyRegisterDetailDialog,
    };
}

function openAddOrEditGroupCompanyRegisterModal(state, { mode, data }) {
    if (mode === 'ADD' || !data) {
        return {
            ...state,
            groupCompanyRegisterModal: {
                ...initialState.groupCompanyRegisterModal,
                isOpened: true,
                mode: 'ADD',
                fields: initialModalFields,
            },
        };
    }

    const rawEndDate = data.endDate || CURRENT_END_DATE;
    const isCurrentEndDate = rawEndDate === CURRENT_END_DATE || rawEndDate === 'Current';
    const attachmentFileList = [];

    if (data.attachment) {
        attachmentFileList.push({
            uid: '-1',
            name: data.attachmentOriginName || data.attachment,
            status: 'done',
            url: state.groupCompanyRegisterDownloadUrl + '/' + data.attachment,
            response: {
                respCode: 'S0001',
                data: {
                    fileNameWithTimeStamp: data.attachment,
                    originalFileName: data.attachmentOriginName || data.attachment,
                },
            },
        });
    }

    return {
        ...state,
        groupCompanyRegisterModal: {
            ...initialState.groupCompanyRegisterModal,
            isOpened: true,
            mode,
            fields: {
                ...initialModalFields,
                id: mode === 'COPY' ? undefined : data.id,
                companyCode: data.companyCode,
                information: data.information,
                details: data.details,
                effectiveDate: data.effectiveDate,
                endDate: isCurrentEndDate ? undefined : data.endDate,
                attachment: data.attachment,
                attachmentOriginName: data.attachmentOriginName,
                attachmentFileList,
                lastUpdatedBy: mode === 'COPY' ? undefined : data.lastUpdatedBy,
                lastUpdateTime: mode === 'COPY' ? undefined : data.lastUpdateTime,
            },
        },
    };
}

function resetAddOrEditGroupCompanyRegisterModal(state) {
    return {
        ...state,
        groupCompanyRegisterModal: initialState.groupCompanyRegisterModal,
    };
}

function addOrEditGroupCompanyRegisterChangeInput(state, { name, value }) {
    return {
        ...state,
        groupCompanyRegisterModal: {
            ...state.groupCompanyRegisterModal,
            fields: {
                ...state.groupCompanyRegisterModal.fields,
                [name]: value,
            },
        },
    };
}

function startSubmitAddGroupCompanyRegister(state) {
    return {
        ...state,
        submitAddGroupCompanyRegisterStatus: ACTION_STATUS.LOGINING,
    };
}

function submitAddGroupCompanyRegisterSuccess(state) {
    return {
        ...state,
        submitAddGroupCompanyRegisterStatus: ACTION_STATUS.SUCCESS,
    };
}

function submitAddGroupCompanyRegisterFailure(state, err) {
    return {
        ...state,
        submitAddGroupCompanyRegisterStatus: ACTION_STATUS.ERROR,
        groupCompanyRegisterModal: {
            ...state.groupCompanyRegisterModal,
            respErrMsg: err.respMessage,
        },
    };
}

function initSubmitAddGroupCompanyRegisterActionStatus(state) {
    return {
        ...state,
        submitAddGroupCompanyRegisterStatus: ACTION_STATUS.READY,
    };
}

function startSubmitUpdateGroupCompanyRegister(state) {
    return {
        ...state,
        submitUpdateGroupCompanyRegisterStatus: ACTION_STATUS.LOGINING,
    };
}

function submitUpdateGroupCompanyRegisterSuccess(state) {
    return {
        ...state,
        submitUpdateGroupCompanyRegisterStatus: ACTION_STATUS.SUCCESS,
    };
}

function submitUpdateGroupCompanyRegisterFailure(state, err) {
    return {
        ...state,
        submitUpdateGroupCompanyRegisterStatus: ACTION_STATUS.ERROR,
        groupCompanyRegisterModal: {
            ...state.groupCompanyRegisterModal,
            respErrMsg: err.respMessage,
        },
    };
}

function initSubmitUpdateGroupCompanyRegisterActionStatus(state) {
    return {
        ...state,
        submitUpdateGroupCompanyRegisterStatus: ACTION_STATUS.READY,
    };
}

function openDelGroupCompanyRegisterModal(state, data) {
    return {
        ...state,
        delGroupCompanyRegisterModal: {
            ...initialState.delGroupCompanyRegisterModal,
            isOpened: true,
            fields: {
                id: data.id,
            },
        },
    };
}

function resetDelGroupCompanyRegisterModal(state) {
    return {
        ...state,
        delGroupCompanyRegisterModal: initialState.delGroupCompanyRegisterModal,
    };
}

function startSubmitDelGroupCompanyRegister(state) {
    return {
        ...state,
        submitDelGroupCompanyRegisterStatus: ACTION_STATUS.LOGINING,
    };
}

function submitDelGroupCompanyRegisterSuccess(state) {
    return {
        ...state,
        submitDelGroupCompanyRegisterStatus: ACTION_STATUS.SUCCESS,
    };
}

function submitDelGroupCompanyRegisterFailure(state, err) {
    return {
        ...state,
        submitDelGroupCompanyRegisterStatus: ACTION_STATUS.ERROR,
        delGroupCompanyRegisterModal: {
            ...state.delGroupCompanyRegisterModal,
            respErrMsg: err.respMessage,
        },
    };
}

function initSubmitDelGroupCompanyRegisterActionStatus(state) {
    return {
        ...state,
        submitDelGroupCompanyRegisterStatus: ACTION_STATUS.READY,
    };
}

export default createReducer(initialState, {
    [START_QUERY_GROUP_COMPANY_REGISTER]: startQueryGroupCompanyRegister,
    [QUERY_GROUP_COMPANY_REGISTER_SUCCESS]: queryGroupCompanyRegisterSuccess,
    [QUERY_GROUP_COMPANY_REGISTER_FAILURE]: queryGroupCompanyRegisterFailure,
    [INIT_QUERY_GROUP_COMPANY_REGISTER_ACTION_STATUS]: initQueryGroupCompanyRegisterActionStatus,
    [GROUP_COMPANY_REGISTER_QUERY_CHANGE_INPUT]: groupCompanyRegisterQueryChangeInput,
    [SELECT_GROUP_COMPANY_REGISTER]: selectGroupCompanyRegister,
    [OPEN_GROUP_COMPANY_REGISTER_DETAIL_DIALOG]: openGroupCompanyRegisterDetailDialog,
    [RESET_GROUP_COMPANY_REGISTER_DETAIL_DIALOG]: resetGroupCompanyRegisterDetailDialog,
    [OPEN_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL]: openAddOrEditGroupCompanyRegisterModal,
    [RESET_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL]: resetAddOrEditGroupCompanyRegisterModal,
    [ADD_OR_EDIT_GROUP_COMPANY_REGISTER_CHANGE_INPUT]: addOrEditGroupCompanyRegisterChangeInput,
    [START_SUBMIT_ADD_GROUP_COMPANY_REGISTER]: startSubmitAddGroupCompanyRegister,
    [SUBMIT_ADD_GROUP_COMPANY_REGISTER_SUCCESS]: submitAddGroupCompanyRegisterSuccess,
    [SUBMIT_ADD_GROUP_COMPANY_REGISTER_FAILURE]: submitAddGroupCompanyRegisterFailure,
    [INIT_SUBMIT_ADD_GROUP_COMPANY_REGISTER_ACTION_STATUS]: initSubmitAddGroupCompanyRegisterActionStatus,
    [START_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER]: startSubmitUpdateGroupCompanyRegister,
    [SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_SUCCESS]: submitUpdateGroupCompanyRegisterSuccess,
    [SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_FAILURE]: submitUpdateGroupCompanyRegisterFailure,
    [INIT_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_ACTION_STATUS]: initSubmitUpdateGroupCompanyRegisterActionStatus,
    [OPEN_DEL_GROUP_COMPANY_REGISTER_MODAL]: openDelGroupCompanyRegisterModal,
    [RESET_DEL_GROUP_COMPANY_REGISTER_MODAL]: resetDelGroupCompanyRegisterModal,
    [START_SUBMIT_DEL_GROUP_COMPANY_REGISTER]: startSubmitDelGroupCompanyRegister,
    [SUBMIT_DEL_GROUP_COMPANY_REGISTER_SUCCESS]: submitDelGroupCompanyRegisterSuccess,
    [SUBMIT_DEL_GROUP_COMPANY_REGISTER_FAILURE]: submitDelGroupCompanyRegisterFailure,
    [INIT_SUBMIT_DEL_GROUP_COMPANY_REGISTER_ACTION_STATUS]: initSubmitDelGroupCompanyRegisterActionStatus,
});
